import { render, staticRenderFns } from "./stateItem.vue?vue&type=template&id=32b937f8&"
import script from "./stateItem.vue?vue&type=script&lang=js&"
export * from "./stateItem.vue?vue&type=script&lang=js&"
import style0 from "./stateItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports